var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveattnew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.78,
    height: 11.78,
    viewBox: "0 0 11.78 11.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407",
    transform: "translate(-1212 -416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    transform: "translate(1212 416)",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.89,
    cy: 5.89,
    r: 5.89,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.89,
    cy: 5.89,
    r: 5.39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    transform: "translate(1215.729 419.181) rotate(42)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 7.164,
    height: 0.895,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.39544808864593506h7.163681507110596M6.663681507110596,0v0.8954480886459351M7.163681507110596,0.5h-7.163681507110596M0.5,0.8954480886459351v-0.8954480886459351",
    fill: "none",
    clipPath: "url(#clip)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    transform: "translate(1220.98 419.836) rotate(137)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-2",
    width: 7.164,
    height: 0.895,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.39547210931777954h7.163683891296387M6.663683891296387,0v0.8954721093177795M7.163683891296387,0.5h-7.163683891296387M0.5,0.8954721093177795v-0.8954721093177795",
    fill: "none",
    clipPath: "url(#clip-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveattnew);
export default __webpack_public_path__ + "static/media/Removeattnew.f5183b8ba396b19c9ced2fa879370bf6.svg";
export { ForwardRef as ReactComponent };